export type LandingStatKey = 'users' | 'entries' | 'resolved' | 'voting';

export type LandingStats = Record<LandingStatKey, number>;

export const LANDING_STAT_KEYS: LandingStatKey[] = ['users', 'entries', 'resolved', 'voting'];

export const LANDING_STATS_FALLBACK: LandingStats = {
  users: 113,
  entries: 737,
  resolved: 140,
  voting: 22,
};

/**
 * Точные числа до 9999, начиная с 10000 — «10k+», «20k+» и т.д.
 * Решение продукта: пока на лендинге начало роста — показываем
 * реальные цифры, после первого 10k округляем чтобы не пересчитывалось
 * на глазах у юзера.
 */
export function formatStatValue(n: number): string {
  if (!Number.isFinite(n) || n < 0) return '0';
  const rounded = Math.floor(n);
  if (rounded < 10000) return rounded.toLocaleString('ru-RU');
  const thousands = Math.floor(rounded / 1000);
  return `${thousands}k+`;
}
